import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography, Box } from '@mui/material';
import { format } from 'date-fns';

import { shortDateFormat } from 'shared/constants/dateFormat';

const ShopProductActivationModal = ({ open, onClose, onConfirm, product }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onClose();
    onConfirm();
  };

  return (
    <div>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>
          <Typography variant="h4">
            {t('Reactivation:')} {product.name}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            {t(
              'We are happy to hear that you have decided to reactivate the following subscription:',
            )}
          </Typography>

          <Box mt={4}>
            <Typography>
              {t('Subscription:')} <strong>{product.name}</strong>
            </Typography>
            <Typography>
              {t('Reactivation date:')} <strong>{format(new Date(), shortDateFormat)}</strong>
            </Typography>
            <Typography>
              {t('Subscription ends:')}{' '}
              <strong>{format(new Date(product.subscriptionUntil), shortDateFormat)}</strong>
            </Typography>
          </Box>
          <Box mt={4}>
            <Typography>
              {t(
                'If you want to move ahead and reactivate the subscription, please confirm your selection below.',
              )}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" variant="outlined">
            {t('Cancel')}
          </Button>
          <Button onClick={handleConfirm} color="primary" variant="contained" autoFocus>
            {t('Confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

ShopProductActivationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
};

export { ShopProductActivationModal };
